import _typeof from "@babel/runtime/helpers/esm/typeof";
import { pxToRem } from '../../../../lib';
import { getColorScheme } from '../../colors';
var labelStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    var colors = getColorScheme(v.colorScheme, p.color);
    return Object.assign({
      display: 'inline-flex',
      alignItems: 'center',
      overflow: 'hidden',
      height: v.height,
      lineHeight: v.height,
      color: colors.background,
      backgroundColor: colors.foreground,
      fontSize: pxToRem(14),
      borderRadius: pxToRem(3),
      padding: v.padding
    }, p.image && (p.imagePosition === 'start' ? {
      paddingLeft: v.startPaddingLeft
    } : {
      paddingRight: v.endPaddingRight
    }), p.circular && {
      borderRadius: v.circularRadius
    });
  },
  image: function image(_ref2) {
    var v = _ref2.variables;
    return {
      height: v.height,
      width: v.height
    };
  },
  icon: function icon(_ref3) {
    var p = _ref3.props;
    return p.icon && _typeof(p.icon) === 'object' && p.icon.onClick && {
      cursor: 'pointer'
    };
  }
};
export default labelStyles;